/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetTasksByCourseModuleParams = {
  user_id?: string | null;
  include?: string | null;
  as_admin?: unknown;
  version?: string | null;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
